function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 13 13"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.352 2.796a3.05 3.05 0 0 1-.893 2.157c-.572.572-1.417.88-2.157.894-.74.013-.795 1.292 0 1.292s1.585.321 2.157.894a3.05 3.05 0 0 1 .893 2.156c0 .863 1.295.863 1.294 0 0-.809.322-1.584.894-2.156s1.354-.86 2.155-.894.794-1.292 0-1.292a3.05 3.05 0 0 1-3.049-3.05c-.012-.834-1.281-.834-1.294 0m.646 2.137c.188.326.356.665.627.935.27.27.61.437.936.625-.325.188-.666.354-.936.624s-.439.61-.627.935c-.188-.325-.354-.665-.624-.935s-.611-.436-.937-.624c.326-.188.666-.354.937-.625.27-.27.436-.61.624-.935",
  style: {
    baselineShift: "baseline",
    display: "inline",
    overflow: "visible",
    opacity: 1,
    vectorEffect: "none",
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.924118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stopColor: "#000",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.544 8.342a.647.647 0 0 0-.648.637.59.59 0 0 1-.584.586c-.82.04-.82 1.252 0 1.293a.583.583 0 0 1 .584.586c0 .863 1.294.863 1.294 0a.59.59 0 0 1 .585-.586c.82-.04.82-1.252 0-1.293a.583.583 0 0 1-.585-.586.647.647 0 0 0-.646-.637",
  style: {
    baselineShift: "baseline",
    display: "inline",
    overflow: "visible",
    vectorEffect: "none",
    fill: "#000",
    stroke: "none",
    strokeWidth: 0.924118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stopColor: "#000"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.536.937a.647.647 0 0 0-.648.637.59.59 0 0 1-.585.587c-.82.04-.82 1.252 0 1.292a.583.583 0 0 1 .585.587c0 .863 1.294.863 1.294 0a.59.59 0 0 1 .585-.587c.82-.04.82-1.252 0-1.292a.583.583 0 0 1-.585-.587.647.647 0 0 0-.646-.637",
  style: {
    baselineShift: "baseline",
    display: "inline",
    overflow: "visible",
    vectorEffect: "none",
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.924118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stopColor: "#000"
  }
}));
export default SvgSparkles;